<template lang="html">
  <div class="wrapper margin-menu">
    <section class="intro column-center -patio">
      <h2>Emprendimiento</h2>
      <h1>Patio Campus</h1>
    </section>

    <section class="breadcrumb">
      <nav class="container row-end">
        <router-link to="/">Inicio</router-link>
        <router-link :to="$t('enlaces.lafundacion')">La Fundación</router-link>
        <router-link :to="$t('enlaces.patio')">Patio Campus</router-link>
      </nav>
    </section>

    <main>
      <div class="container">
        <h2 class="title-intro">
          <img src="/static/img/logo-patio.svg" alt="Logo Patio Campus" />
        </h2>

        <p class="texto-intro">
          
            Un espacio neutral que nace con el objetivo de convertirse en el
            punto de encuentro del ecosistema innovador, conectando
            corporaciones, emprendedores, administración pública y todos
            aquellos agentes necesarios para que la innovación ocurra.
        </p>
      </div>

      <div class="polo-objetivo row-start container ais">
        <h2 class="big-title -left">Objetivo</h2>
        <div class="red-border-box">
          <h2 class="title-intro">El <strong>Objetivo</strong></h2>
          <p>
            <strong
              >Con nuestros procesos de Innovación Abierta buscamos dar
              soluciones innovadoras a retos de impacto y sostenibilidad
              global.</strong
            >
          </p>
        </div>
        <img
          src="/static/img/imagen-objetivo-patio.jpg"
          alt="Imagen objetivo patio"
        />
      </div>
      <div class="container patio-servicios">
        <h2 class="big-title -left">Servicios</h2>
        <p class="p-intro">
          <strong
            >“Creativity is just connecting things” y eso es justo lo que
            hacemos en PATIO Campus. Tanto si hablamos con una gran corporación
            o si todavía no te has decidido a emprender.
          </strong>
        </p>
        <div class="container-servicios">
          <div
            class="servicio-el"
            v-for="(servicio, key) in $t('serviciosPatio')"
          >
            <img :src="'/static/img//patio-' + key + '.jpg'" :alt="servicio" />
            <p>{{ servicio }}</p>
          </div>
        </div>
      </div>
      <div class="contenedor-programas-polo container">
        <h2 class="big-title left">Programas</h2>
        <p class="p-intro">
          <strong
            >Con nuestros procesos de Innovación Abierta buscamos dar soluciones
            innovadoras a retos de impacto y sostenibilidad global.</strong
          >
        </p>
        <p class="p-intro">
          <strong
            >Participa en alguno de nuestros desafíos o inspírate con nuestras
            convocatorias:
          </strong>
        </p>
        <article class="programa-el row-center ais">
          <div class="contenedor-texto">
            <h2>Economía Circular</h2>
            <p>
              Si tienes una propuesta sostenible que impulse la economía
              circular, descubre los retos propuestos por las corporaciones
              impulsoras del programa y ¡aporta tu solución!
            </p>
          </div>

          <img
            src="/static/img/economia-circular.jpg"
            alt="imagen programa impulso pymes"
          />
        </article>

        <article class="programa-el row-center ais">
          <img
            src="/static/img/madrid-abierto.jpg"
            alt="imagen programa iman ideas"
          />

          <div class="contenedor-texto">
            <h2>Madrid Abierto</h2>
            <p>
              Buscamos startups que impulsen la sucesión de negocios
              tradicionales en la Comunidad de Madrid y transformen su tejido
              empresarial.
            </p>
          </div>
        </article>

      
      </div>

      <div class="banner-fondo-patio">
        <p>El campus de referencia global en innovación y sostenibilidad.</p>
        <a href="https://www.patiocampus.org/" target="_blank" class="btn with-border">Ir a la web</a>
      </div>

    </main>
  </div>
</template>

<script lang="js">

export default {
  name: 'polo',
}
</script>



// WEBPACK FOOTER //
// src/components/views/patio.vue